import { render, staticRenderFns } from "./asset-selection-dropdown.vue?vue&type=template&id=54dbee5a"
import script from "./asset-selection-dropdown.vue?vue&type=script&lang=js"
export * from "./asset-selection-dropdown.vue?vue&type=script&lang=js"
import style0 from "./asset-selection-dropdown.vue?vue&type=style&index=0&id=54dbee5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports